import { TemplateList } from '../../../../features/notifications/components/TemplateList';
import { usePageTitle } from '../../../../lib/hooks';

export function NotificationsTemplatesPage() {
  usePageTitle('Notifications Templates');
  return (
    <div className="space-y-6">
      <TemplateList />
    </div>
  );
}
